export default "__VITE_ASSET__BOnvqKkW__"